var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.96786C4 4.43333 4.43333 4 4.96786 4H27.2C31.2281 4 34.6241 6.70639 35.6687 10.4H23.2C21.4327 10.4 20 11.8327 20 13.6V36H13.6V20H10.4V36H4.06226C4.02787 36 4 35.9721 4 35.9377V21.6V18.4V4.96786ZM23.2 36H27.2C32.0601 36 36 32.0601 36 27.2C36 24.2237 34.5225 21.5926 32.2609 20C34.3176 18.5517 35.7258 16.2445 35.9641 13.6L23.2 13.6V36ZM12 8.8C10.2327 8.8 8.8 10.2327 8.8 12C8.8 13.7673 10.2327 15.2 12 15.2C13.7673 15.2 15.2 13.7673 15.2 12C15.2 10.2327 13.7673 8.8 12 8.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.76e3339295f43cbe5eb66665b43f97c2.svg";
export { ForwardRef as ReactComponent };